import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content relative" }
const _hoisted_3 = {
  class: "mt-[19px] relative",
  id: "upcomingEventsSlides"
}
const _hoisted_4 = { class: "relative ltr:pl-[14px] rtl:pr-[14px]" }
const _hoisted_5 = { class: "text-sm mb-[5px] font-semibold" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = { class: "text-primary-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarContent = _resolveComponent("CalendarContent")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }, [
      _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Working Schedule")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CalendarContent),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "block mb-[14px] font-medium" }, " Upcoming Events: ", -1)),
        _createVNode(_component_Swiper, {
          slidesPerView: 1,
          loop: true,
          autoplay: {
            delay: 8000,
            disableOnInteraction: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          modules: _ctx.modules,
          class: "mySwiper"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, {
                class: "cursor",
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute ltr:left-0 rtl:right-0 top-[4px] w-[7px] h-[7px] rounded-sm bg-primary-500" }, null, -1)),
                    _createElementVNode("h6", _hoisted_5, " Pythons Unleashed: " + _toDisplayString(item.title), 1),
                    _createElementVNode("span", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(item.date), 1),
                      _createTextVNode(" - " + _toDisplayString(item.startTime) + " - " + _toDisplayString(item.endTime), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules"]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
      ])
    ])
  ]))
}